module.exports = __webpack_public_path__ + "static/media/242 Park - Sign Posting 2.a592dff9.jpeg";